import api from './api'

export const crudsService = {
  tipoNormaLegal(casoUso, object) {
    if (casoUso === 'new') return api.post('/api/v1.0/spa/tnl/', object)
    if (casoUso === 'edit') return api.put('/api/v1.0/spa/tnl/', object)
    if (casoUso === 'delete') return api.delete(`/api/v1.0/spa/tnl/?id=${object.id}`)
  },

  uo(casoUso, object) {
    if (casoUso === 'new') return api.post('/api/v1.0/spa/uo/', object)
    if (casoUso === 'edit') return api.put('/api/v1.0/spa/uo/', object)
    if (casoUso === 'delete') return api.delete(`/api/v1.0/spa/uo/?id=${object.id}`)
  },

  vozNormaLegal(casoUso, object) {
    if (casoUso === 'new') return api.post('/api/v1.0/spa/vnl/', object)
    if (casoUso === 'edit') return api.put('/api/v1.0/spa/vnl/', object)
    if (casoUso === 'delete') return api.delete(`/api/v1.0/spa/vnl/?id=${object.id}`)
  },

  afectacionNormaLegal(casoUso, object) {
    if (casoUso === 'new') return api.post('/api/v1.0/spa/anl/', object)
    if (casoUso === 'edit') return api.put('/api/v1.0/spa/anl/', object)
    if (casoUso === 'delete') return api.delete(`/api/v1.0/spa/anl/?id=${object.id}`)
  },

  oficina(casoUso, object) {
    if (casoUso === 'new') return api.post('/api/v1.0/spa/oficina/', object)
    if (casoUso === 'edit') return api.put('/api/v1.0/spa/oficina/', object)
    if (casoUso === 'delete') return api.delete(`/api/v1.0/spa/oficina/?id=${object.id}`)
  },

  oficinaTipoNormaLegal(oficina, oficinaTipoNlList) {
    const tipos_nl = oficinaTipoNlList.map(t => ({ id_tipo_nl: t.id }))
    return api.post('/api/v1.0/spa/oficina_tnl/', {
      id_oficina: oficina.id,
      tipos_nl,
    })
  },

  oficinaNotif(casoUso, object) {
    if (casoUso === 'new') return api.post('/api/v1.0/spa/oficina_notif/', object)
    if (casoUso === 'edit') return api.put('/api/v1.0/spa/oficina_notif/', object)
    if (casoUso === 'delete') return api.delete(`/api/v1.0/spa/oficina_notif/?id=${object.id}`)
  },
}

export default crudsService
